export default __webpack_public_path__ + "static/media/invoice.8ef30450.png";